import { Badge, BadgeProps } from '@amzn/awsui-components-console';
import React from 'react';

const RecorderBadge = ({ color }: BadgeProps) => {
  return <Badge color={color || 'green'}>REC</Badge>;
};

export default RecorderBadge;
